(function () {

  // ── Load more ────────────────────────────
  var loadMoreBtn = document.querySelector('.v4-load-more');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      var revealed = 0;
      var isMobile = window.matchMedia('(max-width: 989px)').matches;

      if (isMobile) {
        var cssHidden = Array.from(document.querySelectorAll(
          '.v4-reviews__grid > li:not(.v4-reviews__item--bar)' +
          ':not(.v4-reviews__item--hidden)' +
          ':not(.v4-reviews__item--mobile-show)' +
          ':nth-child(n+5)'
        ));
        cssHidden.slice(0, 3).forEach(function (item) {
          item.classList.add('v4-reviews__item--mobile-show');
          revealed++;
        });
      }

      if (revealed < 3) {
        var jsHidden = document.querySelectorAll('.v4-reviews__item--hidden');
        Array.from(jsHidden).slice(0, 3 - revealed).forEach(function (item) {
          item.classList.remove('v4-reviews__item--hidden');
          revealed++;
        });
      }

      var remainJs  = document.querySelectorAll('.v4-reviews__item--hidden').length;
      var remainCss = isMobile
        ? document.querySelectorAll(
            '.v4-reviews__grid > li:not(.v4-reviews__item--bar)' +
            ':not(.v4-reviews__item--hidden)' +
            ':not(.v4-reviews__item--mobile-show)' +
            ':nth-child(n+5)'
          ).length
        : 0;

      if (remainJs === 0 && remainCss === 0) {
        var wrap = loadMoreBtn.closest('.v4-reviews__actions-left');
        if (wrap) wrap.hidden = true;
      }
    });
  }

  // ── Form AJAX submit ─────────────────────
  var form = document.querySelector('.v4-review-form');
  if (!form) return;

  var successBox = document.querySelector('.v4-review-form__success');
  var submitBtn  = form.querySelector('.v4-review-form__submit');
  var submitText = submitBtn && submitBtn.querySelector('.v4-review-form__submit-text');
  var submitLoad = submitBtn && submitBtn.querySelector('.v4-review-form__submit-loading');

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    if (!form.checkValidity()) { form.reportValidity(); return; }

    submitBtn.disabled = true;
    if (submitText) submitText.hidden = true;
    if (submitLoad) submitLoad.hidden = false;

    try {
      var res = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      });

      if (res.ok) {
        var details = form.closest('details');
        if (details) details.open = false;
        form.reset();
        if (successBox) {
          successBox.hidden = false;
          successBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        submitBtn.disabled = false;
        if (submitText) submitText.hidden = false;
        if (submitLoad) submitLoad.hidden = true;
      } else {
        alert('Something went wrong. Please try again.');
        submitBtn.disabled = false;
        if (submitText) submitText.hidden = false;
        if (submitLoad) submitLoad.hidden = true;
      }
    } catch (_) {
      alert('Network error. Please check your connection and try again.');
      submitBtn.disabled = false;
      if (submitText) submitText.hidden = false;
      if (submitLoad) submitLoad.hidden = true;
    }
  });

})();